import { Box, Grid, Slider, TextField } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";


interface ImageSettingsSliderProps {
  id: string;
  title: string;
  icon: JSX.Element;
  value: number;
  onChange: (value: number) => void;
  max?: number;
  min?: number;
}

export function ImageSettingsSlider(props: ImageSettingsSliderProps) {
  const { icon, value, onChange, id, title, min = 0, max = 200 } = props;

  return (
    <Box
      id={id}
      sx={{
        width: "132.5px",
        height: "20px",
      }}
    >
      <Typography
        id={`${id}-title`}
        data-testid={`${id}-title`}
        variant="small"
        gutterBottom
        fontWeight="semibold"
        align="center"
        color="#919599"
        sx={{ marginBottom: 0 }}
      >
        {title}
      </Typography>
      <Typography id={`${id}-title-value`} className="sr-only" gutterBottom>
        {title} value
      </Typography>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid item id={`${id}-icon`}>{icon}</Grid>
        <Grid item xs>
          <Slider
            id={`${id}-slider`}
            data-testid={`${id}-slider`}
            size="small"
            aria-labelledby={`${id}-slider`}
            aria-describedby={`${id}-description`}
            value={value}
            onChange={(_, newValue) => onChange(newValue as number)}
            max={max}
            name={`${id}-slider`}
            sx={{
              "& .MuiSlider-track": {
                height: "4px",
              },
              "& .MuiSlider-rail": {
                height: "4px",
              },

              "& .MuiSlider-thumb": {
                height: "6px",
                width: "5.45px",
              },
            }}
          />
        </Grid>
        <Grid item>
          <TextField
            id={`${id}-value`}
            data-testid={`${id}-value`}
            sx={{
              width: "19px",
              padding: 0,
              "& .MuiInputBase-input": {
                paddingRight: "0px", // Remove right padding
                fontSize: "12px",
              },
            }}
            type="number"
            value={value}
            variant="standard"
            size="small"
            name={`${id}-value`}
            onChange={(e) => onChange(Number(e.target.value))}
            fullWidth
            hiddenLabel
            inputProps={{
              "aria-labelledby": `${id}-value`,
              "aria-describedby": `${id}-description`,
              min,
              max,
              style: {
                padding: 0,
              },
            }}
          />
        </Grid>
      </Grid>
      <Typography id={`${id}-description`} data-testid={`${id}-description`} className="sr-only">
        Enter a value between 0 and 200.
      </Typography>
    </Box>
  );
}
